document.addEventListener('DOMContentLoaded', () => {
    const tabsContainer = document.querySelector('.tabs-container');
    const tabsContainerProductInfo = document.querySelector('.tabs-container-product-info');

    if (tabsContainerProductInfo && tabsContainer) {
        tabsContainerProductInfo.appendChild(tabsContainer);
        tabsContainer.classList.remove('page-width');
    }

    const tabsNav = tabsContainer?.querySelector('.tabs-nav');
    const tabsContent = tabsContainer?.querySelector('.tabs-content');

    if (!tabsNav || !tabsContent) return;

    const allTabLinks = tabsNav.querySelectorAll('[role="tab"]');
    const allTabPanels = tabsContent.querySelectorAll('[role="tabpanel"]');

    allTabPanels.forEach(panel => {
        normalizePhoneLinks(panel);
    });

    function deactivateAllTabs() {
        allTabLinks.forEach(tab => {
            tab.setAttribute('aria-selected', 'false');
            tab.setAttribute('tabindex', '-1');
            tab.parentElement.classList.remove('active');
        });

        allTabPanels.forEach(panel => {
            panel.classList.remove('active');
            panel.setAttribute('aria-hidden', 'true');
        });
    }

    function activateTab(targetTab) {
        const targetPanelId = targetTab.getAttribute('href').substring(1);
        const targetPanel = tabsContainer.querySelector(`#${targetPanelId}`);
        if (!targetPanel) return;

        deactivateAllTabs();

        targetTab.setAttribute('aria-selected', 'true');
        targetTab.setAttribute('tabindex', '0');
        targetTab.parentElement.classList.add('active');

        targetPanel.classList.add('active');
        targetPanel.setAttribute('aria-hidden', 'false');

        targetTab.focus();
    }

    function handleClick(event) {
        if (event.target.tagName !== 'A') return;
        event.preventDefault();
        activateTab(event.target);
    }

    function handleKeydown(event) {
        const currentTab = document.activeElement;
        if (currentTab.getAttribute('role') !== 'tab') return;

        const currentIndex = Array.from(allTabLinks).indexOf(currentTab);
        let newIndex = currentIndex;

        switch (event.key) {
            case 'ArrowRight':
                newIndex = (currentIndex + 1) % allTabLinks.length;
                break;
            case 'ArrowLeft':
                newIndex = (currentIndex - 1 + allTabLinks.length) % allTabLinks.length;
                break;
            case 'Home':
                newIndex = 0;
                break;
            case 'End':
                newIndex = allTabLinks.length - 1;
                break;
            default:
                return; // Ignore other keys
        }

        event.preventDefault();
        activateTab(allTabLinks[newIndex]);
    }

    tabsNav.addEventListener('click', handleClick);
    tabsNav.addEventListener('keydown', handleKeydown);
});
